// 対立軸の書籍画面（特定の一冊に対する対立書を提案）
import { escapeHtml, screenHead, showScreen, showLoading, hideLoading, toast, renderHistorySection, bindHistoryHandlers } from '../ui.js';
import { fetchContrast } from '../api.js';
import { getAllBooks, saveAiHistory, getAiHistoryByType } from '../cache.js';

export async function showContrastScreen(book) {
  if (book) {
    await runContrast(book);
    return;
  }
  // ホームから入った場合は本を選ぶ
  const books = await getAllBooks();
  if (!books.length) {
    showScreen('contrast', `${screenHead('対立軸の書籍')}<p class="empty">先に Notion 同期を実行してください。</p>`);
    document.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
    return;
  }
  await renderPicker(books);
}

async function renderPicker(books) {
  const sorted = [...books].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'ja'));
  const histItems = await getAiHistoryByType('contrast');
  const html = `
    ${screenHead('対立軸の書籍')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 16px;">
      対立軸を見たい書籍を選んでください。
    </p>
    ${renderHistorySection(histItems)}
    <p class="section-label" style="margin-top:32px;">select a book</p>
    <ul style="list-style:none;padding:0;margin:0;border-top:1px solid var(--line);">
      ${sorted
        .map(
          (b) => `
        <li class="book-item" data-book-id="${escapeHtml(b.id)}">
          <div class="book-body">
            <p class="book-title">${escapeHtml(b.name)}</p>
            <p class="book-author">${escapeHtml(b.author || '')}</p>
          </div>
          <svg class="icon action__chevron"><use href="#i-arrow-right"/></svg>
        </li>
      `
        )
        .join('')}
    </ul>
  `;
  const screen = showScreen('contrast-pick', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  screen.querySelectorAll('[data-book-id]').forEach((li) => {
    li.addEventListener('click', () => {
      const book = books.find((b) => b.id === li.dataset.bookId);
      if (book) runContrast(book);
    });
  });
  bindHistoryHandlers(
    screen,
    histItems,
    (entry) => renderResult(entry.payload, entry.context?.book || {}),
    () => renderPicker(books)
  );
}

async function runContrast(book) {
  showLoading('対立軸を分析中…');
  try {
    const result = await fetchContrast(book);
    await saveAiHistory({
      type: 'contrast',
      title: `対立軸: ${book.name}`,
      subtitle: book.author,
      context: { book },
      payload: result,
    });
    renderResult(result, book);
  } catch (e) {
    toast('分析に失敗しました');
  } finally {
    hideLoading();
  }
}

export function renderFromHistory(entry) {
  renderResult(entry.payload, entry.context?.book || {});
}

function renderResult(result, book) {
  const items = result.items || [];
  const html = `
    ${screenHead('対立軸の書籍')}
    <div style="margin:0 0 24px;padding:12px 16px;border:1px solid var(--line);">
      <p style="margin:0 0 4px;font-family:var(--font-mono);font-size:10px;letter-spacing:0.22em;color:var(--mute);">based on</p>
      <p style="margin:0 0 2px;font-family:var(--font-serif);font-size:15px;font-weight:500;">${escapeHtml(book.name)}</p>
      <p style="margin:0;font-size:12px;color:var(--mute);">${escapeHtml(book.author || '')}</p>
    </div>
    ${items
      .map((item) => {
        const amazonUrl = `https://www.amazon.co.jp/s?k=${encodeURIComponent(item.title + ' ' + (item.author || ''))}`;
        const koshoUrl = `https://www.kosho.or.jp/products/list.php?search_word=${encodeURIComponent(item.title + ' ' + (item.author || ''))}`;
        return `
        <article class="result-card">
          <h3 class="result-card__title">${escapeHtml(item.title)}</h3>
          <p class="result-card__meta">${escapeHtml(item.author || '')}</p>
          <p class="result-card__body"><strong>立場:</strong> ${escapeHtml(item.stance || '')}</p>
          <p class="result-card__body" style="margin-top:8px;"><strong>論点の対立:</strong> ${escapeHtml(item.tension || '')}</p>
          <div class="result-card__chips" style="margin-top:12px;">
            <a class="chip" href="${escapeHtml(amazonUrl)}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">Amazon</a>
            <a class="chip" href="${escapeHtml(koshoUrl)}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">日本の古本屋</a>
          </div>
        </article>
      `;
      })
      .join('')}
  `;
  const screen = showScreen('contrast-result', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
}
